import graphql__9326c8836d2c00efc85d from "./__generated__/AnswerBudgetChapter_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import BudgetChapterField from "../Form/Field/BudgetChapterField";

const AnswerBudgetChapter = function (props) {
  const { values, formField } = useFragment(AnswerBudgetChapter_answer, props.answer);
  const { fieldName, label, required, hint, hintPosition, budgetLines, hide } = formField;
  const { parent, onUpdate, unit, defaultExpanded = false } = props;

  return (
    <BudgetChapterField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      parent={parent}
      budgetLines={budgetLines}
      displayOtherField={false}
      defaultValues={values}
      onUpdate={onUpdate}
      unit={unit}
      defaultExpanded={defaultExpanded}
    />
  );
};

const AnswerBudgetChapter_answer = graphql__9326c8836d2c00efc85d;

export default AnswerBudgetChapter;
